<template>
  <a-card :bordered="false">
    <a-form :label-col="{span:5}" :wrapper-col="{span:15}">
      <a-collapse v-model:activeKey="activeKey">
        <a-collapse-panel key="1" header="基本信息">
          <a-form-item label="门店LOGO">
            <img :src="info.picdomain+form.store_logo" alt="" style="width:80px;height:80px">
          </a-form-item>
          <a-form-item label="门店名称">
            {{form.store_name}}
          </a-form-item>
          <a-form-item label="门店类型">
            {{form.type_name}}
          </a-form-item>
          <a-form-item label="所属上级">
            {{form.is_brand?'总部':form.dealer_name}}
          </a-form-item>
          <a-form-item label="门店级别">
            {{form.level_name}}
          </a-form-item>
          <a-form-item label="门店地址">
            {{form.address}}
          </a-form-item>
          <a-form-item label="负责人">
            {{form.director_name}}
          </a-form-item>
          <a-form-item label="联系手机">
            {{form.director_phone}}
          </a-form-item>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="订货设置">
          <a-form-item label="订货价格模式" v-if="form.type=='detail'">
            {{form.order_set_type_text}}
          </a-form-item>
          <a-form-item label="订货价格模式" v-if="form.type=='edit'">
            <a-radio-group v-model:value="form.order_set_type">
              <a-radio :style="radioStyle" :value="0">使用整体等级折扣率</a-radio>
              <a-radio :style="radioStyle" :value="1">使用订货价格模板</a-radio>
            </a-radio-group>
            <div v-if="form.order_set_type==1">
              <a-input placeholder="请选择模板" v-model:value="form.order_set_type_text" readonly style="width:150px;margin-right:10px"></a-input>
              <a-button @click="chooseTemplate">选择</a-button>
            </div>
          </a-form-item>
        </a-collapse-panel>
      </a-collapse>
       <a-form-item v-if="form.type=='edit'">
              <a-button class="m-t-20" type="primary" @click="save">保存</a-button>
      </a-form-item>
    </a-form>
  </a-card>
<a-modal v-model:visible="templateVisible" centered :width="700" :footer="null">
       <selectDiscountTemplate v-on:select="select" :selectList='[]'></selectDiscountTemplate>
</a-modal>
</template>
<script>
import { ref } from "@vue/reactivity";
import { inject, onMounted } from "@vue/runtime-core";
import { channelDiscountRateStoreSet } from "@/api/online";
import store from "@/store";
import { message } from 'ant-design-vue';
import { iscode } from '../../../../utils/app';
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props,{emit}) {
    const form = ref({});
    const $route = inject("$route");
    onMounted(() => {
      form.value = props.options;
    });
    const activeKey = ref("2");
    const save=async()=>{
      if(form.value.order_set_type==-1){
        message.error('请设置订货模式')
        return
      }
       if(form.value.order_set_type==1&&!form.value.price_tem_id){
        message.error('请选择模板')
        return
      }
     let result=await channelDiscountRateStoreSet(form.value.store_id,{
       order_set_type:form.value.order_set_type,
       price_tem_id:form.value.price_tem_id,
       store_id:form.value.store_id
     }).then(res=>res.data).catch(error=>error)
     if(iscode(result,true)){
       emit('success')
     }
    }
    const templateVisible=ref(false)
    const chooseTemplate=()=>{
        templateVisible.value=true
    }
    const select=(data)=>{
        templateVisible.value=false
        form.value.price_tem_id=data.id
        form.value.order_set_type_text=data.tem_name
    }
    return {
      form,
      info: store.state.user.info,
      activeKey,
      templateVisible,
      chooseTemplate,
      select,
      save
    };
  },
};
</script>